import { useFormState } from 'components/elements/form';
import useActivityColumn from 'components/elements/table/editable-columns/activity-column';
import TableInput from 'components/elements/table/table-input';
import useTranslation from 'next-translate/useTranslation';
import * as React from 'react';
import { useFieldArray, useFormContext, useWatch } from 'react-hook-form';

import { _columns } from './table-column';
import { ActivityRescheduleFormType } from '../../form-type';

interface Props {
  guestIdx: number;
  parentIndex: number;
  isSelected?: boolean;
}

function reducer(state, action, { update, clearErrors, name, setValue }) {
  switch (action.type) {
    case 'update_cell':
      return {
        ...state,
        data: state.data.map((row, index) => {
          if (index === action.rowIndex) {
            const columnId: 'price' | 'qty' = action.columnId;
            const tempValue = {
              ...state.data[action.rowIndex],
              [action.columnId]: action.value,
            };
            if (columnId === 'price') {
              tempValue.price = action.value;
              tempValue.qty = row.qty;
              tempValue.totalPrice = action.value * row.qty;
            }
            if (columnId === 'qty') {
              tempValue.qty = action.value;
              tempValue.price = row.price;
              tempValue.totalPrice = action.value * row.price;
            }
            // update(action.rowIndex, tempValue);
            clearErrors(`${name}.${action.rowIndex}.${action.columnId}`);
            setValue(`${name}.${index}`, tempValue, {
              shouldValidate: true,
            });

            return tempValue;
          }
          return row;
        }),
      };
    case 'update_all':
      return {
        ...state,
        data: action.newData,
      };
    case 'isSelected':
      return {
        ...state,
        data: state.data.map((row, index) => {
          const tempValue = {
            ...state.data[index],
            isSelected: action.value,
          };
          clearErrors(name);
          // update(index, tempValue);
          setValue(`${name}.${index}`, tempValue, { shouldValidate: true });

          return tempValue;
        }),
      };
    default:
      return state;
  }
}

export default function NewActivityTable(props: Props) {
  const { t } = useTranslation();
  const { editable } = useFormState();
  const [isInitiate, setIsInitiate] = React.useState<boolean>(false);
  const { control, clearErrors, setValue } =
    useFormContext<ActivityRescheduleFormType>();

  const name =
    `activitySales.${props.parentIndex}.activitySaleGuests.${props.guestIdx}.activitySaleGuestDetails` as const;

  const fields = useWatch({
    control,
    name,
  });

  const { update } = useFieldArray({
    control,
    name,
    keyName: '__customId',
  });

  const activityColumn = useActivityColumn();

  const columns = (dispatch?: any) =>
    _columns({
      t,
      editable: editable && !!props.isSelected,
      name,
      dispatch,
      activityColumn,
    });
  const [state, dispatch] = React.useReducer(
    (state, action) =>
      reducer(state, action, {
        update,
        clearErrors,
        name,
        setValue,
      }),
    {
      columns: columns(),
      data: [],
    },
  );

  React.useEffect(() => {
    if (!isInitiate) {
      dispatch({
        type: 'update_all',
        newData: fields.length ? fields : [],
      });
      setIsInitiate(true);
    }
  }, [fields, isInitiate]);

  return (
    <div style={{ width: '100%' }}>
      <TableInput
        columns={columns(dispatch) as any}
        data={state.data}
        dispatch={dispatch}
        noAddRemoveRow
        name={name}
        uniqueRowKey="customId"
        disabled={!editable || !props.isSelected}
        onCustomDisabledCell={({ accessorKey, rowOriginal }) =>
          !!(accessorKey !== 'isSelected' && !rowOriginal.isSelected)
        }
      />
    </div>
  );
}
